module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Regular_1_aa80c050.1c118126.ttf";